import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _TYPES$SET_CURRENT_IM;

import * as TYPES from './types';
export default (_TYPES$SET_CURRENT_IM = {}, _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.SET_CURRENT_IMAGE, function (state, image) {
  var currentState = state;
  currentState.currentImage = image;
}), _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.RESET_CURRENT_IMAGE, function (state) {
  var currentState = state;
  currentState.currentImage = null;
}), _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.SET_PRODUCT_CAROUSELS, function (state, product) {
  var currentState = state;
  currentState.productCross = product.cross;
  currentState.productComplementary = product.complementary;
}), _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.SET_PRODUCT, function (state, product) {
  var currentState = state;
  currentState.productCross = product.cross;
  currentState.productInspiration = product.inspiration;
  currentState.productComplementary = product.complementary;
  currentState.product = product;
  currentState.variants = product.variants || [];
}), _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.SET_PRODUCT_IMAGES, function (state, _ref) {
  var images = _ref.images;
  state.images = images;
}), _defineProperty(_TYPES$SET_CURRENT_IM, TYPES.RESET_PRODUCT, function (state) {
  var currentState = state;
  currentState.productCross = null;
  currentState.productComplementary = null;
  currentState.productInspiration = null;
  currentState.product = null;
  currentState.images = [];
  currentState.variants = [];
}), _TYPES$SET_CURRENT_IM);